var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "114px",
    viewBox: "0 0 114 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo - svg Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo---svg-Copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OCTO-Logo-Retraced-01",
    transform: "translate(3, 3)",
    stroke: "#013362"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 3,
    points: "0 77.04 0 31.91 31.91 0 77.04 0 108.96 31.91 108.96 77.04 77.04 108.96 31.91 108.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "17.28 22.33 22.93 22.38 22.93 16 31.17 16 31.18 29.47 2.47 29.47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 16.26,
    cy: 22.32,
    r: 1.15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "1.02 36.16 24.89 36.21 24.89 40.55 36.21 40.55 36.21 47.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "16.25 36.2 16.26 70.72 44.48 70.72 44.48 95.35 57.54 95.35 57.54 78.14 50.89 78.14 50.89 87.43"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 50.91,
    cy: 88.57,
    r: 1.15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "63.3 78.42 63.3 95.27 70.06 95.27 70.06 85.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5.52 81.93 5.52 41.4 10.4 41.4 10.4 70.26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 16.25,
    cy: 81.47,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 38.02,
    cy: 93.12,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 61.66,
    cy: 17.42,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 10.38,
    cy: 70.65,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 49.84,
    cy: 17.35,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 79.56,
    cy: 26.24,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#013362",
    fillRule: "nonzero",
    cx: 98.28,
    cy: 28.08,
    r: 1.15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10.36 86.1 10.36 76.05 38.02 76.05 38.02 91.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "21.13 96.66 21.13 81.45 17.4 81.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "26.65 103.33 26.65 81.48 32.47 81.45 32.47 108.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "37.87 107.99 37.87 101.32 84.69 101.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "44.28 64.78 22.92 64.77 22.92 54.66 16.74 54.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "44.47 46.05 44.47 35.54 36.96 35.54 36.96 0.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "42.55 0.73 42.55 24.18 56.24 24.18 56.24 12.56 67.31 12.56 67.31 38.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "73.29 35.67 73.29 6.97 49.82 6.97 49.82 16.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "36.79 29.92 61.65 29.92 61.65 18.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "87.51 9.9 79.55 9.9 79.55 25.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "92.6 15.29 85.76 15.29 85.76 28.16 92.1 28.16 92.1 45.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "107.96 38.28 98.24 38.28 98.27 29.23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.52,
    y1: 21.6,
    x2: 86.16,
    y2: 21.6,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "31.25 0.03 31.25 9.55 22.86 9.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 3,
    points: "108.72 45.35 88.92 45.43 82.72 33.57 75.88 33.49 70.06 38.75 51.52 38.68 46.18 46.61 29.21 48.73 33.29 60.28 43.35 64.76 60.87 74.51 83.89 101.14"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcto);
export default __webpack_public_path__ + "static/media/octo.2389d5ebed880d949d2ca5b580a418c9.svg";
export { ForwardRef as ReactComponent };